module.exports = __webpack_public_path__ + "static/img/afmAboutImg.66961e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/afmAboutImg.png
// module id = hJRB
// module chunks = 1